import React, { useState, useEffect } from 'react';
import { Form, Modal } from 'semantic-ui-react';
import { ResetPassword } from '../providers/AuthenticationProvider';
import { copyObject } from '../utility';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';

export interface IResetPasswordModal {
  open: boolean;
  initialValues: ResetPassword;
  resetMessage: string;

  onSubmit(_values: ResetPassword): void;
  onCancel(): void;
}

const ResetPasswordModal = (props: IResetPasswordModal) => {
  const { initialValues, open, onSubmit, onCancel, resetMessage } = props;
  const [values, setValues] = useState<ResetPassword>();

  const { t } = useTranslation();

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  const handleChange = (_e: any, data: any) => {
    let copy = copyObject(values);
    copy[data.name] = data.value;
    setValues(copy);
  };

  return (
    <Modal open={open} as={Form} style={{ width: 600 }}>
      {values && (
        <>
          <Modal.Header>{resetMessage}</Modal.Header>
          <Modal.Content>
            <Form.Input
              name="email"
              label={t('home.email')}
              value={values.email}
              onChange={handleChange}
            />
            <Form.Input
              name="password"
              label={t('general.password')}
              value={values.password}
              onChange={handleChange}
              type='password'
            />
            <Form.Input
              name="password_confirmation"
              label={t('general.passwordConfirmation')}
              value={values.password_confirmation}
              onChange={handleChange}
              type='password'
            />
            <FlexRow fullWidth right>
              <Form.Button onClick={onCancel} color="grey">
                {t('general.cancel')}
              </Form.Button>
              <Form.Button onClick={() => onSubmit(values)} color="green">
                {t('general.save')}
              </Form.Button>
            </FlexRow>
          </Modal.Content>
        </>
      )}
    </Modal>
  );
};

export default ResetPasswordModal;
